// dashboard/frontend/src/components/Campaign/channels/instagram/InstagramDraftActions.js

import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import {
    Visibility as VisibilityIcon,
    VisibilityOff as VisibilityOffIcon,
    Refresh as RefreshIcon,
    Delete as DeleteIcon,
    Send as SendIcon,
} from '@mui/icons-material';

/**
 * Instagram-specific action buttons for draft rows
 * These are the buttons that appear in the Actions column
 */
const InstagramDraftActions = ({ 
    draft, 
    contact, 
    hasChannelInfo, 
    expanded, 
    setExpanded,
    onOpenDialog,
    onRefreshDraft,
    onDeleteDraft,
}) => {
    // No draft yet - show generate button if contact has Instagram URL
    if (!draft) {
        if (hasChannelInfo && onRefreshDraft) {
            return (
                <Tooltip title="Generate draft">
                    <IconButton size="small" onClick={() => onRefreshDraft(contact.id)}>
                        <RefreshIcon />
                    </IconButton>
                </Tooltip>
            );
        }
        return null;
    }

    // Draft exists - show Instagram-specific actions
    return (
        <>
            {/* View/Hide button - toggle expanded view */}
            <Tooltip title={expanded ? "Hide" : "Preview"}>
                <IconButton size="small" onClick={() => setExpanded(!expanded)}>
                    {expanded ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </IconButton>
            </Tooltip>
            
            {/* Send button - opens the IG DM dialog (only if not sent yet) */}
            {draft.status !== 'sent' && onOpenDialog && (
                <Tooltip title="Send IG DM">
                    <IconButton
                        size="small"
                        color="primary"
                        onClick={() => onOpenDialog(draft)}
                    >
                        <SendIcon />
                    </IconButton>
                </Tooltip>
            )}
            
            {/* Regenerate button (only if not sent yet) */}
            {draft.status !== 'sent' && onRefreshDraft && (
                <Tooltip title="Regenerate">
                    <IconButton
                        size="small"
                        onClick={() => onRefreshDraft(contact.id)}
                    >
                        <RefreshIcon />
                    </IconButton>
                </Tooltip>
            )}
            
            {/* Delete button */}
            {onDeleteDraft && (
                <Tooltip title="Delete draft">
                    <IconButton
                        size="small"
                        color="error"
                        onClick={() => onDeleteDraft(draft.id)}
                    >
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
            )}
        </>
    );
};

export default InstagramDraftActions;